import { render } from "./embed.vue?vue&type=template&id=537c4b8a"
import script from "./embed.vue?vue&type=script&lang=js"
export * from "./embed.vue?vue&type=script&lang=js"

import "./embed.vue?vue&type=style&index=0&id=537c4b8a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__